/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import { DashBoardShimmer } from '../shimmering';
import AdminDashboard from '../../containers/adminDashboardContainer';

function DashBoard(props) {
  
  // useEffect(() => {
  //   props.set_view_get_limit();
  // }, []);

  return (
    <Grid
      xs={24}
      justify="flex-start"
      alignItems="flex-start"
      className="height-100Vh"
    >
      {!Object.keys(props.userInfo).length ? (
        <DashBoardShimmer />
      ) : 
        <AdminDashboard
          userInfo={props.userInfo}
          orgLimit={props.org_limit}
          userLimit={props.user_limit}
          isAdmin={props.userInfo.has_role}
        />
      }
    </Grid>
  );
}

export default React.memo(DashBoard);

DashBoard.propTypes = {
  userInfo: PropTypes.object,
  org_limit: PropTypes.object,
  user_limit: PropTypes.object,
  set_view_get_limit: PropTypes.func,
};

DashBoard.defaultProps = {
  userInfo: {
    first_name: '',
    has_role: false,
  },
  org_limit: {
    given: 0,
    spent: 0,
  },
  user_limit: {
    given: 0,
    spent: 0,
  },
};
